import { render, staticRenderFns } from "./ScrollText.vue?vue&type=template&id=f987c5b6&scoped=true"
import script from "./ScrollText.vue?vue&type=script&lang=js"
export * from "./ScrollText.vue?vue&type=script&lang=js"
import style0 from "./ScrollText.vue?vue&type=style&index=0&id=f987c5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f987c5b6",
  null
  
)

export default component.exports